import { clamp } from './forecast';

export function cycleLength(plan) {
  return Number(plan?.green || 0) + Number(plan?.yellow || 0) + Number(plan?.red || 0);
}

export function optimizeSignalPlan(plan, arms = [], crossings = []) {
  const currentCycle = cycleLength(plan);
  const worstVc = Math.max(0, ...arms.map((arm) => Number(arm.vc || 0)));
  const pedestrianMinimum = Math.max(0, ...crossings.map((crossing) => Number(crossing.minGreen || 0)));
  const extraGreen = worstVc > 0.8 ? Math.round((worstVc - 0.75) * 22) : 2;
  const green = Math.max(pedestrianMinimum, clamp(Number(plan.green || 0) + extraGreen, 12, 70));
  const yellow = clamp(Number(plan.yellow || 3), 2, 8);
  const red = clamp(currentCycle - green - yellow, 12, 90);
  return {
    green,
    yellow,
    red,
    cycle: green + yellow + red,
    pedestrianMinimum,
    pedestrianConstrained: pedestrianMinimum > Number(plan.green || 0),
  };
}

export function impactFromPlans(current, optimized, worstVc = 0) {
  const gain = Math.max(0.04, Math.min(0.32, (optimized.green - current.green) / Math.max(current.green, 1) * 0.5 + worstVc * 0.08));
  return {
    delay: { current: Math.round(42 + worstVc * 35), optimized: Math.round((42 + worstVc * 35) * (1 - gain)), unit: 's/veicolo' },
    stops: { current: Math.round(760 + worstVc * 500), optimized: Math.round((760 + worstVc * 500) * (1 - gain * 0.8)), unit: 'stop/h' },
    co2: { current: Math.round(128 + worstVc * 60), optimized: Math.round((128 + worstVc * 60) * (1 - gain * 0.65)), unit: 'kg/h' },
  };
}
